module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-stone-path.44b5dd4e.png";